module.exports = __webpack_public_path__ + "static/media/login-center.720981cc.png";